import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const toggleCreditUsage = api.injectEndpoints({
  endpoints: builder => ({
    toggleCreditUsage: builder.mutation<Response, Request>({
      query: ({id}) => {
        return {
          method: 'POST',
          url: `credit-invoices/${id}/toggle-usage`,
        };
      },
    }),
  }),
});

type Request = {
  id?: ObjectId;
};

type Response = ResponseData<{affected_row: ObjectId}>;

export const {useToggleCreditUsageMutation} = toggleCreditUsage;
